export default class MouvementStockService {
	static $inject = ['$http'];

	constructor($http) {
		this.$http = $http;
	}

	async getSocietes() {
		let url = `${__configuration.apiUrl}/massia/societes-commerciales`;
		let res = await this.$http.get(url);
		return res.data;
	}

	async getRegroupementSites(societeId) {
		const res = await this.$http.get(`${__configuration.apiUrl}/massia/regroupement-sites/societe/${societeId}`);
		return res.data;
	}
	async getProduits(regoupementSiteId) {
		const res = await this.$http.get(`${__configuration.apiUrl}/massia/regroupement-sites/${regoupementSiteId}/produits`);
		return res.data;
	}

	async getMouvementsStockByProduit(idProduit, idProducteur, idRegoupementSite, dateDebut, dateFin) {
		let filtres = {
			idProduit: idProduit,
			idProducteur: idProducteur,
			idRegoupementSite: idRegoupementSite,
			dateDebut: dateDebut,
			dateFin: dateFin
		};
		let url = `${__configuration.apiUrl}/massia/mouvements-stock-produit`;
		let res = await this.$http.get(url, {
			params: {
				filtres: JSON.stringify(filtres || {})
			}
		});
		return res.data;
	}

	async getMouvementsStockProduitInfosByDay(idRegoupementSite, idProduit, idProducteur, date) {
		let filtres = {
			idProduit: idProduit,
			idProducteur: idProducteur,
			idRegoupementSite: idRegoupementSite,
			date: date
		};
		let url = `${__configuration.apiUrl}/massia/mouvements-stock-produit/infos-by-day`;
		let res = await this.$http.get(url, {
			params: {
				filtres: JSON.stringify(filtres || {})
			}
		});
		return res.data;
	}
}
